export default {
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state: {
    userId: '',
    userName: '',
    isHorizontalDisplay: '',
  },
  mutations: {
    setUserId(state, userId) {
      state.userId = userId;
    },
    setUserName(state, userName) {
      state.userName = userName;
    },
    setIsHorizontalDisplay(state, isHorizontalDisplay) {
      state.isHorizontalDisplay = isHorizontalDisplay;
    },
  },
  getters: {
    getUserId: (state) => {
      return state.userId;
    },
    getUserName: (state) => {
      return state.userName;
    },
    getIsHorizontalDisplay: (state) => {
      return state.isHorizontalDisplay;
    },
  },
};
